export const toast = {
  colorScheme: {
    dark: {
      error: {
        background: '{red.200}',
        color: '{red.600}',
        detailColor: '{red.600}',
      },
      success: {
        background: '{green.200}',
        color: '{green.600}',
        detailColor: '{green.600}',
      },
    },
  },
};
